import { useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Button } from '@/components/ui/button'
import ChangePasswordDialog from './ChangePasswordDialog'
import PermissionsViewerDialog from './PermissionsViewerDialog'
import { useMe } from '@/hooks/useMe'

export default function UserAvatarMenu() {
  const navigate = useNavigate()
  const { user } = useMe()
  const [open, setOpen] = useState(false)
  const [showChangePassword, setShowChangePassword] = useState(false)
  const [showPermissions, setShowPermissions] = useState(false)

  const initial = useMemo(() => {
    const name = user?.user_name || user?.account || 'U'
    return (name || 'U').slice(0, 1).toUpperCase()
  }, [user])

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            aria-label="user-menu"
            className="h-9 w-9 rounded-full bg-primary/90 text-white flex items-center justify-center shadow hover:bg-primary"
          >
            <span className="text-sm font-semibold">{initial}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-56 p-2">
          <div className="px-2 py-2 border-b mb-2">
            <div className="text-sm font-medium">
              {user?.user_name || user?.account}
            </div>
            <div className="text-xs text-muted-foreground">{user?.role_type || ''}</div>
          </div>
          <div className="space-y-1">
            <Button
              variant="ghost"
              className="w-full justify-start"
              onClick={() => {
                setOpen(false)
                navigate('/settings/account')
              }}
            >
              管理帳號
            </Button>
            <Button
              variant="ghost"
              className="w-full justify-start"
              onClick={() => {
                setOpen(false)
                setShowChangePassword(true)
              }}
            >
              修改密碼
            </Button>
            <Button
              variant="ghost"
              className="w-full justify-start"
              onClick={() => {
                setOpen(false)
                setShowPermissions(true)
              }}
            >
              權限瀏覽
            </Button>
          </div>
        </PopoverContent>
      </Popover>
      <ChangePasswordDialog open={showChangePassword} onOpenChange={setShowChangePassword} />
      <PermissionsViewerDialog open={showPermissions} onOpenChange={setShowPermissions} />
    </>
  )
}
